<template>
  <v-dialog v-model='dialog' max-width='500px'>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Legend
      </v-card-title>
      <v-card-text>
        <div v-for='state in states'
          :key='state'
        >
          <v-icon :color='notificationColor(state)'>
            {{ notificationIcon(state) }}
          </v-icon>
          {{ legend[state] }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class='oem-button' flat @click='dialog = false'>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'helpNotificationLegend',
  props: {
    page: String,
  },
  data() {
    return {
      dialog: false,
      states: [0, 1, 2, 3],
      legend: [
        'Page is configured, valid and uploaded to device',
        'Page is configured and valid but not yet uploaded to device',
        'Page has configured elements which are not used',
        'Page has configuration errors. Cannot upload configuration to device',
      ],
    };
  },
  methods: {
    show() {
      this.dialog = true;
    },
    notificationIcon(state) {
      if (state === 3) {
        return 'report';
      }
      if (state === 2) {
        return 'warning';
      }
      if (state === 1) {
        return 'vertical_align_top';
      }
      if (state === 0) {
        return 'check';
      }
      return '';
    },
    notificationColor(state) {
      if (state === 3) {
        return 'red darken-2';
      }
      if (state === 2) {
        return 'orange darken-2';
      }
      if (state === 1) {
        return 'orange darken-2';
      }
      if (state === 0) {
        return 'green darken-2';
      }
      return '';
    },
  },
};
</script>
